import { Pipe, PipeTransform } from '@angular/core';

import { SortService } from "../services/sort.service";

@Pipe({
  name: 'sort'
})
export class SortPipe implements PipeTransform {
  constructor(
    private _sortService: SortService
  ){}
  
  transform(value: any, args: any[], desc?: boolean): any {
    var returned: any = this._sortService.sortArray(value, args, desc);
    return returned;
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/shared/pipes/sort.pipe.ts
 **/